import React from 'react'

const TextInput = (props) => {
  const {
    id,
    name,
    formSet,
    value,
    pattern,
    placeholder,
    onChange,
    formRef = null,
    errors = {},
    icon = null,
    type = 'text',
    inputLabelsMap,
    errorsMap
  } = props

  return (
    <div className={`form-input ${!icon && 'without-icon' }`}>
      <input
        id={id}
        className="input"
        type={type}
        name={`${formSet}[${name}]`}
        value={value}
        pattern={pattern}
        placeholder={placeholder}
        onChange={e => onChange({ [name]: e.target.value })}
        ref={formRef}
      />

      <label
        className={icon ? `label label-icon ${icon}` : `label`}
        htmlFor={id}
      >
        {!value && <span className="label-content">{inputLabelsMap[name]}</span>}
      </label>

      {errors && errors[name] && (
        <span className="input-error">{errorsMap[errors[name].type]}</span>
      )}
    </div>
  )
}

export default TextInput
